import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { flattenData } from "../../../../Utilitie";
import * as echarts from "echarts";

const CrackMonthlyTotalGraph = ({
  data,
  sections,
  selectedMonths,
  months,
  selectedFy,
}) => {
  useEffect(() => {
    if (selectedMonths.length === 0) return;

    const chartDom = document.getElementById("CrackChart2");
    let myChart = echarts.init(chartDom);

    const prevYearTotal = {};
    const currYearTotal = {};

    months.forEach((month) => {
      prevYearTotal[month] = 0;
      currYearTotal[month] = 0;
    });

    sections.forEach((section) => {
      const prevData = section.children[0]?.data || [];
      const currData = section.children[1]?.data || [];

      prevData.forEach(({ month_name, total_no_of_crack }) => {
        prevYearTotal[month_name] += Number(total_no_of_crack) || 0;
      });

      currData.forEach(({ month_name, total_no_of_crack }) => {
        currYearTotal[month_name] += Number(total_no_of_crack) || 0;
      });
    });

    const grandPrevTotal = selectedMonths.reduce(
      (acc, m) => acc + (prevYearTotal[m] || 0),
      0
    );

    const grandCurrTotal = selectedMonths.reduce(
      (acc, m) => acc + (currYearTotal[m] || 0),
      0
    );

    const option = {
      title: {
        text: `Grand Total Comparison`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      xAxis: {
        type: "category",
        data: ["Prev Total", "Curr Total"],
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "Grand Totals",
          type: "bar",
          data: [grandPrevTotal, grandCurrTotal],
          label: {
            show: true,
            position: "top",
            fontSize: 13,
          },
        },
      ],
    };

    myChart.setOption(option);

    // ------------------ RESPONSIVE FIX ------------------ //
    const handleResize = () => {
      if (myChart) myChart.resize();
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (myChart) myChart.dispose();
    };
  }, [selectedMonths, selectedFy, data]);

  return (
    <div className="newUiBody">
      <div
        id="CrackChart2"
        style={{
          width: "100%",
          height: "50vh",
          minHeight: "350px",
          marginTop: "30px",
        }}
      ></div>
    </div>
  );
};

export default CrackMonthlyTotalGraph;
